module.exports = __webpack_public_path__ + "img/favicon.1f013951.png";